import {axiosClient, setToken} from "../axios-client"

export const login = (data) => axiosClient.post(
  '/auth/token/',
  data,
).then((res) => setToken(res.data.access))

export const register = data => axiosClient.post('/register/', data)